import React from 'react';
import T from 'prop-types';
// components
import ReactTimeAgo from 'react-timeago';
// translate
import { FormattedMessage } from 'react-intl';
// regional date handling
import { connect } from 'react-redux';
import { getCurrentCountryCode } from 'selectors/regionalDateSelectors';
import { formatDateForUser } from 'utils/regionalDateHelper';
// utils
import moment from 'moment';

const TimeAgo = ({
  date,
  formatter,
  className,
  countryCode,
}) => {
  const formattedTitle = formatDateForUser(date, countryCode) + ' ' + moment(date).format('HH:mm');
  return (
    <ReactTimeAgo
      date={date}
      title={formattedTitle}
      formatter={formatter}
      className={className}
    />
  );
};

TimeAgo.defaultProps = {
  formatter: (value, unit) => (
    <FormattedMessage
      id={`component.timeAgo.${value > 1 ? unit + 's' : unit}`}
      values={{ value }}
    />
  ),
};

TimeAgo.propTypes = {
  date: T.any,
  className: T.string,
  formatter: T.func,
  countryCode: T.string,
};

export default connect(
  (state) => ({
    countryCode: getCurrentCountryCode(state),
  })
)(TimeAgo);
